import styled from "@emotion/styled";
import {
    breakpoints,
    colors,
    fontSizes,
    fontWeights,
    gutterSizes,
    lineHeights,
    mediaQuery,
} from "@gumtree/ui-library/src/base/theme";

const shouldForwardProp = (p: string) => !["isForSaleCategory"].includes(p);

export const StyledWrapper = styled("div", { shouldForwardProp })<{}>`
    margin-top: ${gutterSizes.xxlarge};
    margin-bottom: 34px;

    ${mediaQuery.from(breakpoints.large)} {
        margin: ${gutterSizes.base} 50px 97px;
    }
`;

export const StyledTilte = styled.div`
    font-size: ${fontSizes.xlarge};
    color: ${colors.barkDark};
    line-height: ${lineHeights.large};
    margin-bottom: ${gutterSizes.large};

    > span {
        font-weight: ${fontWeights.bold};
        margin-right: ${gutterSizes.base};
    }

    span:last-child {
        margin-left: ${gutterSizes.base};
    }

    ${mediaQuery.from(breakpoints.xsmall)} {
        margin-bottom: ${gutterSizes.xlarge};
    }
`;

export const StyledFooter = styled.div`
    font-weight: ${fontWeights.normal};
    font-size: ${fontSizes.base};
    line-height: ${lineHeights.base};
    color: ${colors.barkDark};
    max-width: 433px;
    margin-top: ${gutterSizes.base};
    margin-bottom: ${gutterSizes.large};

    ${mediaQuery.from(breakpoints.xsmall)} {
        margin-top: ${gutterSizes.large};
        margin-bottom: ${gutterSizes.xlarge};
    }
`;
